import { Button, withStyles } from "@material-ui/core";

const ActionButton = withStyles( theme => ({
  root: {
    color: "#ffffff",
    borderColor: "#ffffff",
    backgroundColor: undefined,
    padding: "0px 8px",
    '&:hover': {
      backgroundColor: "rgba(0,0,0,0.1)",
    },
  }
}))(Button);

export {
  ActionButton
}